import { render, staticRenderFns } from "./SelectModalTabMenu.vue?vue&type=template&id=ae124f52"
import script from "./SelectModalTabMenu.vue?vue&type=script&lang=js"
export * from "./SelectModalTabMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports